import { render, staticRenderFns } from "./PriorityTypes.vue?vue&type=template&id=883fd812&"
import script from "./PriorityTypes.vue?vue&type=script&lang=js&"
export * from "./PriorityTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports